import { render, staticRenderFns } from "./AppointmentList_1.vue?vue&type=template&id=b2346780"
import script from "./AppointmentList_1.vue?vue&type=script&lang=js"
export * from "./AppointmentList_1.vue?vue&type=script&lang=js"
import style0 from "./AppointmentList_1.vue?vue&type=style&index=0&id=b2346780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports